// D22 (B2_04/B2_05) — signal visuel de désambiguïsation du slug partagé entre facettes
// (« tesla » thème vs entité) : préfixe « # » pour un thème, « @ » pour une entité.
// Source UNIQUE de la constante — consommée par le composeur (FacetSelector) et par
// toutes les surfaces d'affichage (FacetBadges).
export type FacetType = 'theme' | 'entity';

export const FACET_PREFIX: Record<FacetType, string> = {
  theme: '#',
  entity: '@',
};
